module.exports = "https://static.wmbcdn.com/uniweb/images/ab76fec0f6db9f0d189ae66fb036dbf2.svg";